<main class="main">
  @if (isLoggedIn && !hasFramelessLayout) {
    <ysh-main-header
      [userName]="$safeNavigationMigration(currentUser?.name)" 
      [activeMobileMenu]="activeMobileMenu"
      (onTapMobileMenu)="didTapMobileMenu()"
      (onTapLogout)="didTapLogout()"
    />
    <ysh-main-aside
      [activeMobileMenu]="activeMobileMenu"
      (click)="didTapMobileMenu()"
    />
  }
  <section class="content" [class.loading]="isLoading">
    @if (isLoading) {
      <ysh-dots size="medium" />
    } @else {
      <router-outlet />
    }
  </section>
</main>
<ysh-toast />
<ysh-dialog />
